import React from 'react';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';

export interface IconToggleOption {
  value: string;
  label: string;
  icon: React.ReactElement;
  disabled?: boolean;
  disabledTooltip?: string;
}

interface IconToggleGroupProps {
  value: string;
  options: IconToggleOption[];
  onChange: (value: string) => void;
  ariaLabel: string;
}

const IconToggleGroup: React.FC<IconToggleGroupProps> = ({ value, options, onChange, ariaLabel }) => (
  <ToggleButtonGroup
    className="icon-toggle-group"
    dir="ltr"
    exclusive
    size="small"
    value={value}
    aria-label={ariaLabel}
    onChange={(_, nextValue: string | null) => {
      if (nextValue !== null) onChange(nextValue);
    }}
    sx={{
      '& .MuiToggleButton-root': { borderColor: '#d8e0e8', color: '#465b70', padding: '4px 7px' },
      '& .MuiToggleButton-root.Mui-selected': { backgroundColor: '#e1f3fb', color: '#007CB2' },
      '& .MuiToggleButton-root.Mui-selected:hover': { backgroundColor: '#d2edf8' },
    }}
  >
    {options.map((option: IconToggleOption) => (
      <Tooltip key={option.value} title={option.disabled ? option.disabledTooltip ?? option.label : option.label} arrow>
        <span>
          <ToggleButton value={option.value} disabled={option.disabled} aria-label={option.label}>
            {option.icon}
          </ToggleButton>
        </span>
      </Tooltip>
    ))}
  </ToggleButtonGroup>
);

export default IconToggleGroup;
